/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/import-whitelist
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const getData = async (): Promise<any> => {
	try {
		const data = await fetchJson(
			'/gateway/api/jsm/csm/api/v1/migration/customer-context/storage-architecture/status',
		);
		return data.isMigratedToNewStorageArch;
	} catch (error) {
		fireErrorAnalytics({
			meta: {
				id: 'csmCustomerContextTenantMigratedStatusResource',
				packageName: 'jiraRouterResourcesServiceDeskCustomerServiceCsmMigratedTenantStatus',
				teamName: 'Boysenberry',
			},
			error: error instanceof Error ? error : undefined,
		});

		throw error;
	}
};

export default getData;
